"use client";
import * as React from "react";
import { UserIcon } from "./UserIcon";
import { MobileMenu } from "./MobileMenu";

export function ActionButtons() {
  const handleScrollToPlans = () => {
    const el = document.getElementById("nossos-planos");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {/* Desktop and tablet buttons */}
      <div className="d-none d-md-flex align-items-center" style={{ gap: "1rem" }}>
        <button
          className="btn d-flex align-items-center"
          style={{
            gap: "10px",
            padding: "8px 32px",
            border: "1.5px solid #2AAE3F",
            borderRadius: "6px",
            backgroundColor: "transparent",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f9f0")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
          aria-label="Meu Acesso"
          onClick={() =>
            window.open(
              "https://nacaosaude.centraldeatendimento.me/login",
              "_blank"
            )
          }
        >
          <UserIcon />
          <span
            layer-name="Meu Acesso"
            className="fw-bold"
            style={{
              color: "#2AAE3F",
              fontSize: "16px",
            }}
          >
            Meu Acesso
          </span>
        </button>
            
        {/* Peça já o seu → scroll para Nossos Planos */}
        <button
          className="btn d-flex align-items-center"
          style={{
            gap: "10px",
            padding: "8px 32px",
            borderRadius: "6px",
            backgroundColor: "#2AAE3F",
            border: "none",
            transition: "background-color 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#259e3a")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#2AAE3F")}
          onClick={handleScrollToPlans}
        >
          <span
            layer-name="Peça já o seu"
            className="fw-bold text-white"
            style={{ fontSize: "16px" }}
          >
            Peça já o seu
          </span>
        </button>
      </div>

      {/* Mobile menu */}
      <MobileMenu />
    </>
  );
}